import resource from '@/api/promotion/resource'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState,
    branches: [],
    salecodes: [],
    startDate: moment().startOf('M').format('DD-MM-YYYY')
}

export const getters = {
  getProduct: state => ({ chosenProduct, search = '' } = {}) => {
    if(chosenProduct !== undefined){
      return state.salecodes.filter(p => 
        !_.includes(chosenProduct.map(el => el.pro_sale_code_id),p.pro_sale_code_id)
      )
      .filter(p => 
        search.split(' ').every((s) => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
      ).slice(0, 200);
      // return state.salecodes.filter(p => search.split(' ').every((s) => p.product_name_en.includes(s)));
    }
    return state.salecodes.slice(0, 200)
  },
  getProductBuy: state => ({ chosenProduct, search = '' } = {}) => {
    if(chosenProduct !== undefined){
      return state.salecodes.filter(p => 
        !_.includes(chosenProduct.map(el => el.pro_sale_code_id_buy),p.pro_sale_code_id)
      )
      .filter(p => 
        search.split(' ').every((s) => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
      ).slice(0, 200);
    }
    return state.salecodes.slice(0, 200)
  },
  getProductFree: state => ({ chosenProduct, search = '' } = {}) => {
    if(chosenProduct !== undefined){
      return state.salecodes.filter(p => 
        !_.includes(chosenProduct.map(el => el.pro_sale_code_id_free),p.pro_sale_code_id)
      )
      .filter(p => 
        search.split(' ').every((s) => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
      ).slice(0, 200);
    }
    return state.salecodes.slice(0, 200)
  },
  getPrice: state => saleCodeId => {
    let findPrice =  state.salecodes.find(s => s.pro_sale_code_id == saleCodeId)
    if(findPrice){
      return findPrice.price
    }

    return 0;
  },
  getProductName: state => proSaleId => {
    if(proSaleId){
      return state.salecodes.find(s => s.pro_sale_code_id == proSaleId).product_name_en
    }
    return null
  }
}

export const mutations = {
    ...baseMutations,
    SET_BRANCH(state, data){
        state.branches = data
    },
    SET_SALECODE(state, data){
        state.salecodes = data
    },
    SET_DATE_START(state, data){
      state.startDate = data
    },
    CLEAR_SETUP(state){
      state.branches = []
      state.salecodes = []
    }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        dateStart: context.state.startDate,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return resource.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async getBranch(context){
    let response = await resource.getBranch()
    context.commit('SET_BRANCH', response.data)
    return response
  },
  async getSaleCode(context){
    let response = await resource.getSaleCode()
    context.commit('SET_SALECODE', response.data)
    return response
  }
}